import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useEffect } from 'react';
import { useTheme } from 'styled-components';

interface Props extends Omit<Component, 'id'> {
  id: MediaIdType | string;
  onSortChange: (state: boolean) => void;
}

export const SortItem = ({ children, id, onSortChange }: Props) => {
  const { active, attributes, isDragging, isSorting, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const { colors } = useTheme() as { colors: Record<string, string | undefined> };

  const style = {
    borderRadius: '0.25rem',
    boxShadow: isDragging
      ? `0px 0px 0px 1px ${colors.brandDarkAlpha10}, 0px 0.75rem 0.5rem -0.25rem ${colors.brandDarkAlpha15}, 0px 0.25rem 0.25rem -0.125rem ${colors.brandDarkAlpha20}`
      : '0px 0px 0px rgba(0,0,0,0.8)',
    cursor: isDragging ? 'grabbing' : 'grab',
    filter: isSorting && active?.id !== id ? 'grayscale(1) opacity(0.5)' : 'grayscale(0) opacity(1)',
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isSorting && active?.id === id ? 1 : 0,
  };

  useEffect(() => {
    onSortChange(isSorting);
  }, [isSorting]);

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      {children}
    </div>
  );
};
